export type AppRole =
  | 'Admin'
  | 'Gestor de Catálogo'
  | 'Diseño'
  | 'Gerente Comercial'
  | 'Distribuidor'
  | 'Vendedor'

export const websiteContentRoles: AppRole[] = ['Admin', 'Gestor de Catálogo', 'Diseño']
export const productCatalogRoles: AppRole[] = ['Admin', 'Gestor de Catálogo']
export const imageCatalogRoles: AppRole[] = ['Admin', 'Gestor de Catálogo', 'Diseño']

export const getInitialRoute = (role?: string) => {
  if (role === 'Admin' || role === 'Diseño') return '/homepage'
  if (role === 'Gestor de Catálogo') return '/catalogo/productos'
  if (role === 'Gerente Comercial') return '/portal/pedidos'
  if (role === 'Vendedor') return '/portal-vendedor/mis-pedidos'
  if (role === 'Distribuidor') return '/portal/mis-pedidos'
  return '/auth'
}
